import React, { Component } from 'react';

import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { isWeb } from '../../config/designSystem/Layout';

// Instances buttons forward and backward
const ForwardBackward = ({ hideBack, onBack, hideForward, onForward, height, color, colorIcon }) => {
  const heightButton = height;
  const MARGIN_HORIZONTAL = 10;
  return (
    
    <View style={ isWeb ? {display: 'none'} : styles.container}>
      {!hideBack && (
        <TouchableOpacity onPress={onBack}>
          <View
            style={[
              styles.playButtonSmall,
              { marginRight: MARGIN_HORIZONTAL, width: heightButton, height: heightButton, backgroundColor: color },
            ]}
          >
            <MaterialCommunityIcons name="rewind-30" size={heightButton * 0.7} color={colorIcon} />
          </View>
        </TouchableOpacity>
      )}
      {!hideForward && (
        <TouchableOpacity onPress={onForward}>
          <View
            style={[
              styles.playButtonSmall,
              { marginLeft: MARGIN_HORIZONTAL, width: heightButton, height: heightButton, backgroundColor: color },
            ]}
          >
            <MaterialCommunityIcons name="fast-forward-30" size={heightButton * 0.7} color={colorIcon} />
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default ForwardBackward;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 1,
    // paddingTop: 8,
  },
  playButtonSmall: {
    display: 'flex',
    width: 30,
    // paddingLeft: 8,
    // borderWidth: 1,
    // borderColor: '#444',
    // borderRadius: 72 / 2,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#4f9eb5',
    borderRadius: 15,
  },
});
